/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {FsTranslate} from '../model/fsTranslate';
import {SelectItem} from '../model/selectItem';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorPublicI18nCacheService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getByKey
     *
     * @param X_LANG X-LANG
     * @param typeCode typeCode
     * @param key key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByKeyUsingGET(X_LANG: string, typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, observe?: 'body', reportProgress?: boolean): Observable<SelectItem>;
    public getByKeyUsingGET(X_LANG: string, typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SelectItem>>;
    public getByKeyUsingGET(X_LANG: string, typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SelectItem>>;
    public getByKeyUsingGET(X_LANG: string, typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling getByKeyUsingGET.');
        }

        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling getByKeyUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        queryParameters = queryParameters.set('onlyEnable', <any> onlyEnable);
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }

        let headers = this.defaultHeaders;
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<SelectItem>(`${this.basePath}/api/public/v1/i18-cache/fs/value/${encodeURIComponent(String(typeCode))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer les indicatifs téléphoniques des pays
     * Cette requête permet de récupérer les indicatifs téléphoniques des pays.&lt;br&gt;Par exemple : +33 pour la France, +44 pour la Royaume-Uni, +1 pour l&#39;États-Unis, etc.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDialCodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getDialCodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getDialCodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getDialCodeUsingGET(observe: any = 'body', reportProgress = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<string>>(`${this.basePath}/api/public/v1/i18-cache/client/dialcode`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getListDialCode
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getListDialCodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<FsTranslate>>;
    public getListDialCodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FsTranslate>>>;
    public getListDialCodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FsTranslate>>>;
    public getListDialCodeUsingGET(observe: any = 'body', reportProgress = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<FsTranslate>>(`${this.basePath}/api/public/v1/i18-cache/client/dialcode/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer la traduction depuis l&#39;API d&#39;Airiane
     * Cette requête permet de récupérer la traduction depuis l&#39;API d&#39;Airiane.
     * @param typeCode Le type de code (ville, pays, aeroport, etc...)
     * @param codes les codes abrégés des différents données de système à récupérer (par exemple NCE pour la ville de Nice)
     * @param field s&#39;il prend &#39;dial_code&#39; comme valeur et le paramètre : typeCode prend pays (COUNTRY), alors une traduction de l&#39;indicatif du pays concerné est fournie par la requête
     * @param isos Les codes ISO de la langue : fr(Français), en(Anglais), es(Espagnol), etc...
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTraductionFromAirianeUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', codes?: Array<string>, field?: string, isos?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<FsTranslate>>;
    public getTraductionFromAirianeUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', codes?: Array<string>, field?: string, isos?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FsTranslate>>>;
    public getTraductionFromAirianeUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', codes?: Array<string>, field?: string, isos?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FsTranslate>>>;
    public getTraductionFromAirianeUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', codes?: Array<string>, field?: string, isos?: Array<string>, observe: any = 'body', reportProgress = false): Observable<any> {

        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling getTraductionFromAirianeUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codes) {
            codes.forEach((element) => {
                queryParameters = queryParameters.append('codes', <any> element);
            });
        }
        if (field !== undefined && field !== null) {
            queryParameters = queryParameters.set('field', <any> field);
        }
        if (isos) {
            isos.forEach((element) => {
                queryParameters = queryParameters.append('isos', <any> element);
            });
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<FsTranslate>>(`${this.basePath}/api/public/v1/i18-cache/fs/${encodeURIComponent(String(typeCode))}/airiane-api`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer la traduction depuis l&#39;API d&#39;Airiane sous forme de map
     * Cette requête permet de récupérer la traduction depuis l&#39;API d&#39;Airiane sous forme de map.
     * @param X_LANG Les codes ISO de la langue : fr(Français), en(Anglais), es(Espagnol), etc...
     * @param key Un paramètre utilisé pour filter la recherche et renvoyer que les données qui correspondent qui ont comme clé, la clé fournie
     * @param q Il s&#39;agit d&#39;un paramètre qui stocke une chaîne de charactères qui va être cherchée dans la base de données par clé et par valeur
     * @param value Un paramètre utilisé pour filter la recherche et renvoyer que les données qui correspondent qui ont comme valeur, la valeur fournie
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchClientToMapUsingGET(X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public searchClientToMapUsingGET(X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public searchClientToMapUsingGET(X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public searchClientToMapUsingGET(X_LANG?: string, key?: string, q?: string, value?: string, observe: any = 'body', reportProgress = false): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any> q);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any> value);
        }

        let headers = this.defaultHeaders;
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<{ [key: string]: string; }>(`${this.basePath}/api/public/v1/i18-cache/client/map/AFFILIE`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer la traduction depuis l&#39;API d&#39;Airiane sous forme d&#39;array
     * Cette requête permet de récupérer la traduction depuis l&#39;API d&#39;Airiane sous forme d&#39;array.
     * @param X_LANG Les codes ISO de la langue : fr(Français), en(Anglais), es(Espagnol), etc...
     * @param key Un paramètre utilisé pour filter la recherche et renvoyer que les données qui correspondent qui ont comme clé, la clé fournie
     * @param q Il s&#39;agit d&#39;un paramètre qui stocke une chaîne de charactères qui va être cherchée dans la base de données par clé et par valeur
     * @param value Un paramètre utilisé pour filter la recherche et renvoyer que les données qui correspondent qui ont comme valeur, la valeur fournie
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchClientUsingGET(X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SelectItem>>;
    public searchClientUsingGET(X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SelectItem>>>;
    public searchClientUsingGET(X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SelectItem>>>;
    public searchClientUsingGET(X_LANG?: string, key?: string, q?: string, value?: string, observe: any = 'body', reportProgress = false): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any> q);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any> value);
        }

        let headers = this.defaultHeaders;
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<SelectItem>>(`${this.basePath}/api/public/v1/i18-cache/client/array/AFFILIE`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer la traduction depuis l&#39;API d&#39;Airiane sous forme de map
     * Cette requête permet de récupérer la traduction depuis l&#39;API d&#39;Airiane sous forme de map.
     * @param typeCode Le type de code (ville, pays, aeroport, etc...)
     * @param onlyEnable onlyEnable
     * @param X_LANG Les codes ISO de la langue : fr(Français), en(Anglais), es(Espagnol), etc...
     * @param key Un paramètre utilisé pour filter la recherche et renvoyer que les données qui correspondent qui ont comme clé, la clé fournie
     * @param q Il s&#39;agit d&#39;un paramètre qui stocke une chaîne de charactères qui va être cherchée dans la base de données par clé et par valeur
     * @param value Un paramètre utilisé pour filter la recherche et renvoyer que les données qui correspondent qui ont comme valeur, la valeur fournie
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchToMapUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public searchToMapUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public searchToMapUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public searchToMapUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, X_LANG?: string, key?: string, q?: string, value?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling searchToMapUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        queryParameters = queryParameters.set('onlyEnable', <any> onlyEnable);
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any> q);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any> value);
        }

        let headers = this.defaultHeaders;
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<{ [key: string]: string; }>(`${this.basePath}/api/public/v1/i18-cache/fs/map/${encodeURIComponent(String(typeCode))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer la traduction depuis l&#39;API d&#39;Airiane sous forme d&#39;array
     * Cette requête permet de récupérer la traduction depuis l&#39;API d&#39;Airiane sous forme d&#39;array.
     * @param typeCode Le type de code (ville, pays, aeroport, etc...)
     * @param onlyEnable onlyEnable
     * @param X_LANG Les codes ISO de la langue : fr(Français), en(Anglais), es(Espagnol), etc...
     * @param key Un paramètre utilisé pour filter la recherche et renvoyer que les données qui correspondent qui ont comme clé, la clé fournie
     * @param q Il s&#39;agit d&#39;un paramètre qui stocke une chaîne de charactères qui va être cherchée dans la base de données par clé et par valeur
     * @param value Un paramètre utilisé pour filter la recherche et renvoyer que les données qui correspondent qui ont comme valeur, la valeur fournie
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SelectItem>>;
    public searchUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SelectItem>>>;
    public searchUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, X_LANG?: string, key?: string, q?: string, value?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SelectItem>>>;
    public searchUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, X_LANG?: string, key?: string, q?: string, value?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling searchUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        queryParameters = queryParameters.set('onlyEnable', <any> onlyEnable);
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any> q);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any> value);
        }

        let headers = this.defaultHeaders;
        if (X_LANG !== undefined && X_LANG !== null) {
            headers = headers.set('X-LANG', String(X_LANG));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<SelectItem>>(`${this.basePath}/api/public/v1/i18-cache/fs/array/${encodeURIComponent(String(typeCode))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
